import { canFilter } from '../../mixins/can_filter';
import { canPaginate } from '../../mixins/can_paginate';
import { NEW_ADMIN_URL } from 'environment';

angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider.when('/accounts/:account_id/donations', {
        template: require('./account_donations.html'),
        controller: 'AccountDonationsController'
    });
})
.controller('AccountDonationsController', function($scope, $location, $routeParams, Account, Donation) {
    canFilter($scope, $location);
    canPaginate($scope, $location);
    $scope.newAdminURL = NEW_ADMIN_URL;
    $scope.s || ($scope.s = '-created_at');

    const params = _.pick($scope, 'q', 's', 'p');
    params.account_id = $routeParams.account_id;

    $scope.donations = Donation.query(params, function(data, getResponseHeader) {
        const pagination = getResponseHeader('X-Pagination');
        return $scope.pagination = (pagination ? JSON.parse(pagination) : {});
    });
    return $scope.account = Account.get({ id: $routeParams.account_id });
});


// WEBPACK FOOTER //
// ./views/account/account_donations_controller.js